import { useEffect, useState } from "react";
import AppBackdrop from "../../components/AppBackdrop";

export const expirationEventName = "session-expired";

function AppBackdropContainer() {
	const [open, setOpen] = useState(false);
	const handleKeyDown = () => {
		setOpen(true);
	};

	useEffect(() => {
		window.addEventListener(expirationEventName, handleKeyDown);

		return () => {
			window.removeEventListener(expirationEventName, handleKeyDown);
		};
	}, []);

	return <AppBackdrop open={open} />;
}

export default AppBackdropContainer;
